import { Link } from 'react-router-dom'

const AccountExistsButton = () => {
    return (
        <div className="mt-3 text-sm text-gray-500 text-center">
            Already have an account? &nbsp;
            <Link to="/login" className="font-semibold text-ep-primary hover:underline whitespace-nowrap">Log In</Link>
        </div>
    )
}

export default AccountExistsButton